import { Button, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import validator from 'validator';

const ForgotPasswordCard = ({
  email,
  setEmail,
  error,
  handleForgotPassword,
  loading,
}) => {
  return (
    <div className="card-wrapper">
      <div className="card-wrapper-box">
        <h4>Enter your email ID</h4>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleForgotPassword();
          }}
        >
          <div className="input-box">
            <TextField
              fullWidth
              // error={error}
              type="email"
              label="Email Address"
              placeholder="Enter your email address"
              id="forgot-password-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          {error && (
            <div
              className="error-message"
              style={{
                color: 'red',
                marginBottom: '10px',
              }}
            >
              {error}
            </div>
          )}
          <Button
            fullWidth
            variant="contained"
            type="submit"
            id="forgot-password-continue-button"
            disabled={!validator.isEmail(email) || loading}
          >
            {loading ? (
              <CircularProgress style={{ color: '#fff' }} size={26} />
            ) : (
              'Continue'
            )}
          </Button>
        </form>
      </div>

      <div className="sign-up-link">
        <p>
          Remember your password? <Link id="forgot-password-login-link" to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordCard;
